


















































































import VueOptions from '@utils/VueOptions'
import UiList from '@superUI/List/List'
import LoadingIndicator from '@/components/LoadingIndicator'

settings = 
  name: "SponsorOrgSelector"
  components: { UiList, LoadingIndicator }
  resources:
    sponsorSelector:
      # resourceName: 'activation'
      slug: ':resourcePath'
  vue:
    props: [
      'resourcePath',
      'hiSponsorSelected',
      'multi',
      'hiMultiSponsorSelected',
      'hiTopSponsorCampaignSelected'
    ]
    
    data: ->
      selectedTopSponsorId: null
      selectedSubSponsorId: null

      searchTimeout: null
      topSponsorSearch: ''
      subSponsorSearch: ''

      multiSelectedSubSponsors: []

      sponsors: []
      sub_organizations: []
      
    mounted: ->
      @fetchSponsors()

    computed:
      getTopSponsor: ->
        ctx = this
        @sponsors.find((sponsor) -> sponsor.id == ctx.selectedTopSponsorId)

    methods:
      hiSelectTopSponsor: (sponsorId) ->
        @selectedTopSponsorId = sponsorId
        @fetchSponsors('', sponsorId)

      hiSelectSponsor: (sponsor, topSponsor, event) ->
        if !@multi
          @hiSponsorSelected(sponsor)
          return

        if topSponsor
          element = document.querySelector('.topSponsorItem')
          sponsor.topSponsor = true
        else
          element = document.getElementById(sponsor.id)

        element.style.display = 'none'
        @multiSelectedSubSponsors.push(sponsor)

      hiUnselectSponsor: (selectedSponsor) ->
        if selectedSponsor.topSponsor
          element = document.querySelectorAll('.topSponsorItem')
        else
          element = document.getElementById(selectedSponsor.id)

        element.removeAttribute 'style'

        @multiSelectedSubSponsors = @multiSelectedSubSponsors.filter(
          (sponsor) -> sponsor.id != selectedSponsor.id
        )

      hiBack: ->
        if @selectedSponsorId
          @selectedSubSponsorId = null
          @selectedSponsorId = null
        else
          @selectedSubSponsorId = null
          @selectedTopSponsorId = null

        @multiSelectedSubSponsors = []

        @fetchSponsors('', @selectedTopSponsorId)

      fetchSponsors: (q = '', sponsor_id) ->
        ctx = this
        params = {}
        params.page = 1
        params.q = q
        params.sponsor_id = sponsor_id if sponsor_id

        clearTimeout(@searchTimeout)
        @searchTimeout = setTimeout(() ->
          ctx.fetchWithoutStoring(ctx.resourcePath, params).then((result) ->
            if sponsor_id
              ctx.sub_organizations = result
            else
              ctx.sponsors = result
          )
        , 500)

    watch:
      topSponsorSearch: (value) ->
        @fetchSponsors(value)
      
      subSponsorSearch: (value) ->
        @fetchSponsors(value, @selectedTopSponsorId)

export default VueOptions.vue settings
